export default __webpack_public_path__ + "static/media/CurrencyCoin.f1f16d26.png";